import { enhancedApi } from './generated/bulkMattersService';

export const bulkMatterService = enhancedApi.enhanceEndpoints({});

export const { useMattersBulkCreateMutation } = bulkMatterService;
